export default __webpack_public_path__ + "static/media/ledgers.e949c628.png";